import { render, staticRenderFns } from "./InfoPopup.vue?vue&type=template&id=2a620962&lang=html&"
import script from "./InfoPopup.vue?vue&type=script&lang=js&"
export * from "./InfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./InfoPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InfoPopup.vue"
export default component.exports